import React from 'react';
import { Link } from 'react-router-dom';
import { useBeta } from '../../contexts/BetaContext';
import { useSettings } from '../../contexts/SettingsContext';
import './Footer.css';

const Footer = () => {
  const { isBetaMode, basePath } = useBeta();
  const { settings } = useSettings();
  const currentYear = new Date().getFullYear();

  // Show minimal footer in non-beta mode (matches SimpleHomePage)
  if (!isBetaMode) {
    return (
      <footer className="public-footer public-footer-minimal">
        <div className="footer-container">
          <div className="footer-bottom">
            <p>&copy; {currentYear} Martin-Resnick Oscar Party. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="public-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{settings?.shortPartyName || 'MR Oscar Party'}</h3>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to={`${basePath}/`}>Home</Link></li>
              <li><Link to={`${basePath}/submit`}>Ballot</Link></li>
              <li><Link to={`${basePath}/leaderboard`}>Leaderboard</Link></li>
              <li><Link to={`${basePath}/gallery`}>Gallery</Link></li>
              <li><Link to={`${basePath}/past-winners`}>Past Winners</Link></li>
              <li><Link to={`${basePath}/about`}>About</Link></li>
              <li>
                <a
                  href="https://www.instagram.com/mroscarparty/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a href="mailto:bruce_resnick@parkerresnick.com">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} Martin-Resnick Oscar Party. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
